// extracted by mini-css-extract-plugin
export default {"icon-button":"IconButton-module--icon-button--e9ceB"};